// footerLinks.ts
export const socialLinks = [
  {
    href: 'https://ble.ir/mazrae_admin',
    iconClass: 'icon-Bale-icon',
    label: 'Bale',
  },
  {
    href: 'https://api.whatsapp.com/send?phone=989352593515',
    iconClass: 'icon-namewhatsapp',
    label: 'WhatsApp',
  },
  {
    href: 'https://t.me/MazraeMan',
    iconClass: 'icon-telegram',
    label: 'Telegram',
  },
  {
    href: 'https://instagram.com/mazrae_app',
    iconClass: 'icon-nameinstagram',
    label: 'Instagram',
  },
];
